import { ResponseStream } from 'proto/eshop/BasketService_pb_service'

type ListenCallback<T> = (data: T) => void

export interface ObservableStream<T> {
	listen: (callback: ListenCallback<T>) => void
	cancel: () => void
}

export function observableStream<T>(stream: ResponseStream<T>): ObservableStream<T> {
	return {
		listen(callback: (data: T) => void) {
			stream.on('data', callback)
			window.addEventListener('beforeunload', stream.cancel)
		},
		cancel: () => {
			stream.cancel()
			window.removeEventListener('beforeunload', stream.cancel)
		},
	}
}
